import Vue from 'vue';
var Highcharts = require('highcharts');

export default Vue.extend({
  props: {
    series: {
      type: Array,
      required: true,
    },
    tooltipTpl: {
      type: String,
      required: true,
    },
    dataLabels: {
      type: String,
    },
    legend: {
      type: Boolean,
    },
  },
  data() {
    return {
      options: {
        data: [],
      },
      statisticsTpl: '<span class="report-statistics-graf-circle-tooltip">' +
        '<span class="report-statistics-graf-circle-tooltip-name">{point.name}</span>' +
        '<span class="report-statistics-graf-circle-tooltip-percent">Error(s): {point.totalError}</span>' +
        '<span class="report-statistics-graf-circle-tooltip-percent">Error points: {point.totalEP}</span>' +
        '</span>',

      langStatistics: '<div class="qa-result__tooltip"><div>{point.language.SourceLanguage}<span>&raquo;</span>{point.language.TargetLanguage}</div><div>{point.language.taskRating}</div></div>',
      docsStatistics: '<div class="qa-result__tooltip"><div>{point.docs.name}</div><div>{point.docs.rating}</div></div>',
      format: '',

    };
  },
  created() {
    this.options.data = [];
    this.options.data = this.series;
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      const self = this;
      let dataLabels = {
        enabled: false,
        distance: -50,
        allowOverlap: true,
      };

      self.format = self[self.tooltipTpl];

      if (this.dataLabels) {
        dataLabels = {
          enabled: true,
          distance: -50,
          style: {
            fontSize: '16px',
            fontWeight: 'normal',
            color: '#000',
            textOutline: false,
          },
          allowOverlap: true,
        };
      };

      this.chart = Highcharts.chart(self.$el, {
        chart: {
          type: 'pie',
          plotShadow: false,
          plotBorderWidth: null,
          plotBackgroundColor: null,
          height: 450,
          minHeight: 450,
        },
        title: {
          text: '',
        },
        legend: {
          align: 'left',
          verticalAlign: 'bottom',
          itemStyle: {
            color: '#000000',
            fontWeight: '300',
            fontSize: '16px',
            fontFamily: '\'Roboto\', sans-serif',
          },
          width: 300,
          floating: true,
          layout: 'vertical',
          x: 0,
          labelFormatter: function () {
            return this.name.split('(')[0];
          },
          y: 0,
        },
        tooltip: {
          backgroundColor: 'transparent',
          borderColor: 'none',
          borderRadius: 0,
          borderWidth: 0,
          headerFormat: '',
          positioner: function (boxWidth, boxHeight, point) {
            return {
              x: point.plotX - 10,
              y: point.plotY - 35,
            };
          },
          pointFormat: self.format,
          useHTML: true,
          shared: true,
        },
        plotOptions: {
          pie: {
            center: ['55%', '50%'],
            cursor: 'pointer',
            animation: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
            className: 'report-statistics-graf-circle',
            showInLegend: self.legend,
            dataLabels: {
              enabled: true,
              distance: -25,
              formatter: function () {
                return this.y.toFixed() + '%';
              },
            },

          },
          series: {
            events: {
              click: function (event) {
                self.$emit('clickChart', event.point.name);
              },
            },
            connectNulls: true,
          },
        },
        series: [{
          colorByPoint: true,
          data: this.options.data,
          dataLabels: dataLabels,

          point: {
            events: {
              mouseOver: function (e) {
                // this.dataLabel.css({
                //   color: '#fff',
                // });
              },
              mouseOut: function (e) {
                // this.dataLabel.css({
                //   color: '#000',
                // });
              },
            },
          },
        }],
        exporting: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
      });
    },
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
});
